<template>
  <MonitorWrapper>
    <div class="gm-606-container">
      <template v-if="!empty">
        <status-bar v-bind="status"></status-bar>
        <chart-wrap ref="chartWrap" :datas="charts"></chart-wrap>
      </template>
      <template v-else>
        <div class="hint">{{ isHisDetail ? '暂无数据' : '数据加载中...' }}</div>
      </template>
    </div>
  </MonitorWrapper>
</template>

<script>
import StatusBar from './components/status-bar.vue';
import ChartWrap from './components/wrap.vue';
import singleDeviceMixin from '@/mixins/singleDeviceMixin';
import { isObject } from '@/utils/is';

import { makeData } from './utils/faker';

export default {
  name: 'GM606',
  mixins: [singleDeviceMixin],
  components: {
    StatusBar,
    ChartWrap
  },
  sockets: {
    '/socket/detail'(res) {
      if (!res || res.sn !== this.sn) return;
      this.update(res);
    }
  },
  provide() {
    return {
      time: this.time
    };
  },
  data() {
    return {
      status: {
        alarmStatus: 0,
        runState: 0,
        pumpStatus: {
          install: 0,
          run: 0
        },
        humidity: 0,
        temperature: 0,
        absoluteHumidity: 0,
        atmosphericPressure: 0
      },
      charts: [],
      time: {},
      empty: false
    };
  },
  methods: {
    getDetail() {
      this.getHistoryDetailData(this.eventId)
        .then(res => {
          if (!isObject(res) || !isObject(res.data)) return;
          const { deviceData, deviceDatas } = res.data;
          if (!Array.isArray(deviceDatas)) return;
          this.setData(deviceData);
          let mod = null;
          const list = deviceDatas
            .map(e => {
              mod = this.getGM606Mod(e);
              if (!mod) return;
              return { sensors: mod.sensors, beginTime: e.beginTime };
            })
            .filter(e => isObject(e));
          this.$refs.chartWrap.setData(list, this.getGM606Mod(deviceData));
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    getGM606Mod(res) {
      if (!res || !res.mods || !res.mods.gm606Mod) return null;
      return res.mods.gm606Mod;
    },
    setData(res) {
      try {
        const { status, charts } = this;
        const { pumpStatus } = status;
        const { runstate, state, mods, beginTime } = res;
        const { gm606Mod } = mods;
        if (!gm606Mod || !gm606Mod.sensors) return;
        this.time.begin = beginTime;
        Object.assign(status, {
          runState: runstate,
          alarmStatus: state,
          humidity: gm606Mod.humidity,
          temperature: gm606Mod.temp,
          absoluteHumidity: gm606Mod.absoluteHumidity,
          atmosphericPressure: gm606Mod.atmosphericPressure
        });
        Object.assign(pumpStatus, {
          run: gm606Mod.pumpRunstate,
          install: gm606Mod.pumpInstallState
        });
        charts.splice(0, Infinity, ...gm606Mod.sensors);
        this.empty = false;
      } catch (err) {
        console.error('[GM606][MONITRO][update error]', err);
      }
    },
    update(res) {
      if (!this.isHisDetail) this.setData(res);
    },
    enableMock() {
      let num = 1;
      this.mockTimer = setInterval(() => {
        this.update(makeData(num++));
      }, 2000);
    }
  },
  mounted() {
    // this.enableMock();

    if (!this.isHisDetail) return;
    this.$nextTick(() => {
      this.getDetail();
    });
  },
  beforeDestroy() {
    clearInterval(this.mockTimer);
  }
};
</script>

<style lang="scss">
.gm-606-container {
  width: 100%;
  height: 100%;
  span {
    @include state-textstyle;
  }
  .hint {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .common-border2 {
    border: 1px solid rgb(96, 118, 173);
  }
  .common-border {
    height: 100%;
    padding: 2px;
    background-image: url('~@/assets/image/lt.png'), url('~@/assets/image/rt.png'),
      url('~@/assets/image/lb.png'), url('~@/assets/image/rb.png'),
      url('~@/assets/image/linelight.png');
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
    background-position: top left, top right, bottom left, bottom right, center -5px;
    .comp3-content {
      height: 100%;
      box-sizing: border-box;
    }
  }
}
</style>
